import React, { FC } from 'react'
import './index.scss'
interface IProps {
  color?: string;
  bgColor?: string;
  rate: number;
}

const PointBar: FC<IProps> = ({ color, bgColor, rate }: IProps) => {
  return (
    <div
      className='point-card-bar' style={{
        backgroundColor: bgColor || '#ffffff'
      }}
    >
      <div className='progress-bar-block'>
        <div
          className='progress-bar-bg' style={{
            backgroundColor: color || '#161616',
            opacity: 0.3
          }}
        >
        </div>
        <div
          className='progress-bar' style={{
            width: `${rate || 0}%`,
            backgroundColor: color || '#161616',
          }}
        >
        </div>
      </div>
    </div>
  )
}
export default PointBar
